const CHUNK_RELOAD_KEY = 'signup-chunk-reload';
const isAutomatedTest = Boolean(window.navigator.webdriver);
export function isChunkLoadError(error) {
  if (!(error instanceof Error)) {
    return false;
  }
  return error.name === 'ChunkLoadError' || /loading chunk .* failed/i.test(error.message) || /loadable.*split chunk/i.test(error.message);
}
export function shouldAttemptChunkReload() {
  try {
    return !sessionStorage.getItem(CHUNK_RELOAD_KEY);
  } catch (_unused) {
    return false;
  }
}
export function triggerChunkReload() {
  try {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
  } catch (_unused2) {
    return;
  }
  window.location.reload();
}
export function withChunkLoadRecovery(loader) {
  if (isAutomatedTest) {
    return loader;
  }
  return () => loader().catch(error => {
    if (isChunkLoadError(error) && shouldAttemptChunkReload()) {
      triggerChunkReload();
      return new Promise((_, reject) => {
        setTimeout(() => reject(error), 5000);
      });
    }
    throw error;
  });
}